import client from "./client";

export const publicPricing = async () => (await client.get("/pricing")).data;
export const pricingQuote = async (employees, interval = "month") =>
  (await client.get("/pricing/quote", { params: { employees, interval } })).data;
export const updatePricing = async (body) => (await client.put("/platform/pricing", body)).data;

export const submitSignup = async (body) => (await client.post("/signup-requests", body)).data;
export const listSignupRequests = async (status = "pending") =>
  (await client.get("/signup-requests", { params: { status } })).data;
export const approveSignup = async (id) => (await client.post(`/signup-requests/${id}/approve`)).data;
export const rejectSignup = async (id, reason) =>
  (await client.post(`/signup-requests/${id}/reject`, { reason })).data;

export const myBilling = async () => (await client.get("/billing/me")).data;
export const startCheckout = async (interval) =>
  (await client.post("/payments/checkout", { interval, origin_url: window.location.origin })).data;
export const paymentStatus = async (sessionId) => (await client.get(`/payments/status/${sessionId}`)).data;
export const listInvoices = async () => (await client.get("/billing/invoices")).data;
export const invoicePdf = async (number, lang = "ar") =>
  (await client.get(`/billing/invoices/${number}/pdf`, { params: { lang }, responseType: "blob" })).data;
